import React, { useContext, useEffect } from 'react';
import { createContext, useRef, useState } from 'react';
import {
  getClaimchainByPlotID,
  getFlaggedPlotInfoByName,
  getPlotByIDCompact,
} from 'rest_client/apiClient';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { ALL_STATUS } from 'components/FilterButton/FilterPlotStatus';
import { Box } from '@mui/material';
import { CLAIMCHAIN_NUMBER } from 'cml-script';
import Header from 'components/Header';
import PropTypes from 'prop-types';
import axios from 'axios';
import { getPlotStatus } from 'utils/Constants';
import { show } from 'redux/reducers/snackbar';
import { useDispatch } from 'react-redux';
import { useDisclose, useWindowWidth } from 'basic-react-hooks';
import useFetchPublicUserInfo from 'hooks/useFetchPublicUserInfo';

const CancelToken = axios.CancelToken;
let source;
const error = 'fetch claimchain cancel';
const MainContext = createContext();
let _showClaimchain = CLAIMCHAIN_NUMBER.map((i) => i.value);
export const useMainContext = () => useContext(MainContext);
const PLOT_ID = 'id';
const PLOT_NAME = 'name';
const getPadding = (windowWidth) => {
  if (windowWidth < 600) {
    return {
      top: 100,
      left: 100,
      bottom: 100,
      right: 100,
    };
  }
  if (windowWidth < 960) {
    return {
      top: 200,
      left: 200,
      bottom: 200,
      right: 200,
    };
  }
  if (windowWidth < 1280) {
    return {
      top: 200,
      left: 450,
      bottom: 300,
      right: 200,
    };
  }
  return {
    top: 200,
    left: 600,
    bottom: 400,
    right: 200,
  };
};

export const initFilter = {
  status: ALL_STATUS.value,
  showClaimchain: _showClaimchain,
  showUnConnect: true,
};
export default function Layout({ children }) {
  const [plotSelected, setPlotSelected] = useState(null);
  const [plotsSelected, setPlotsSelected] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageList, setImageList] = useState(null);
  const plotSelectedRef = useRef(null);
  const claimchainRef = useRef(null);
  const windowWidthRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const [claimchains, setClaimchains] = useState([]);
  const [claimchainsCluster, setClaimchainsCluster] = useState([]);
  const [fetchingClaimChain, setFetchingClaimChain] = useState(false);
  const [filter, setFilter] = useState(initFilter);
  const [contractCert, setContractCert] = useState(null);
  const [cert, setCert] = useState(null);
  const [buckets, setBuckets] = useState([]);
  const {
    isOpen: isOpenLogin,
    onClose: onCloseLogin,
    onOpen: onOpenLogin,
  } = useDisclose();
  const [certVerify, setCertVerify] = useState({
    index: -1,
    list: [],
    plot: null,
  });
  const [warningVerify, setWarningVerify] = useState(null);
  const windowWidth = useWindowWidth();
  const {
    isOpen: isOpenVerify,
    onOpen: onOpenVerify,
    onClose: onCloseVerify,
  } = useDisclose();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const location = useLocation();
  const dispatch = useDispatch();
  windowWidthRef.current = windowWidth;
  const getPlotData = async (plotId) => {
    try {
      let res = await getPlotByIDCompact(plotId);
      _setPlotSelected(
        { ...res.data.plot, claimchainSize: res.data.claimchainSize },
        true,
      );

      setTimeout(() => {
        selectPolygon({ polygon: res.data.plot.geojson });
      }, 1000);
    } catch (err) {
      console.log(err);
    }
  };
  const getPlotDataByName = async (plotName) => {
    try {
      let res = await getFlaggedPlotInfoByName(plotName);
      _setPlotSelected(
        { ...res.data.plot, claimchainSize: 1, plotFlagged: true },
        true,
        true,
      );
      setTimeout(() => {
        selectPolygon({ polygon: res.data.plot.geojson });
      }, 1000);
    } catch (err) {
      dispatch(
        show({
          message: err?.message || err,
          severity: 'error',
        }),
      );
      console.log(err);
    }
  };
  useEffect(() => {
    let plotId = params.get(PLOT_ID);
    if (plotId && loaded) {
      getPlotData(plotId);
      return;
    }
    let plotName = params.get(PLOT_NAME);
    if (plotName && loaded) {
      getPlotDataByName(plotName);
    }
  }, [loaded]);

  // useEffect(() => {
  //   if (
  //     certVerify?.list?.length > 0 &&
  //     certVerify?.plot?.id !== params.get(PLOT_ID)
  //   ) {
  //     setCertVerify({
  //       index: -1,
  //       list: [],
  //       plot: null,
  //     });
  //     setCert(null);
  //   }
  // }, [params, certVerify]);

  const [claimchain, setClaimchain] = useState({
    plots: [],
    size: 1,
  });
  const mapRef = useRef();
  const setCenter = ({ long, lat, zoom }) => {
    if (!long || !lat) {
      return;
    }
    let data = {
      geometry: {
        coordinates: [long, lat],
      },
    };
    if (zoom) {
      data.zoom = zoom;
    }
    mapRef.current.setCenter(data);
  };
  const selectPolygon = ({ polygon }) => {
    mapRef.current.selectPolygon({
      polygon,
      styles: {
        padding: getPadding(windowWidthRef.current),
      },
    });
  };
  const unSelectPolygon = () => {
    mapRef.current.selectPolygon({ polygon: null });
  };
  const getStatus = (plot) => {
    return getPlotStatus({
      plot,
    });
  };
  const getClaimchainData = async (id) => {
    setFetchingClaimChain(true);
    try {
      let res = {};
      if (source) {
        source.cancel(error);
      }
      source = CancelToken.source();
      res = await getClaimchainByPlotID(id, {
        cancelToken: source.token,
      });
      if (
        claimchainRef.current &&
        res.data.parentPlot === claimchainRef.current.parentPlot
      ) {
        setFetchingClaimChain(false);
        return;
      }
      let cl = res.data;
      let numberClaimchain = cl.plots.length;
      cl.size = numberClaimchain;
      cl.plots = [
        ...cl.plots.map((i) => ({
          ...i,
          status: getStatus(i),
          claimchainSize: numberClaimchain,
        })),
      ];
      claimchainRef.current = cl;
      setClaimchain(cl);
      setFetchingClaimChain(false);
    } catch (err) {
      console.log(err?.message);
      if (err && err.message === error) {
        return;
      }
      setFetchingClaimChain(false);
    }
  };
  const _setPlotSelected = (
    plot,
    selectPlotWithOutClaimchainList,
    doNotNavigate = false,
  ) => {
    if (plot) {
      if (plot._id === plotSelectedRef.current?._id) {
        return;
      }
      setPlotsSelected(null);
      if (!doNotNavigate) {
        const params = new URLSearchParams({ [PLOT_ID]: plot._id });
        navigate(`${location.pathname}?${params.toString()}`);
      }

      setPlotSelected(plot);
      plotSelectedRef.current = plot;
      if (selectPlotWithOutClaimchainList) {
        // claimchainRef.current = null;
        //fetch claimchain data when select plot with claimchain size > 1
        if (plot.claimchainSize > 1) {
          getClaimchainData(plot._id);
        } else {
          //hide claimchain list
          if (source) {
            source.cancel(error);
          }
          setFetchingClaimChain(false);
          setClaimchain({
            size: 1,
            plots: [],
          });
          claimchainRef.current = null;
        }
      }
    } else {
      // clear data when unselect
      navigate(`${location.pathname}`);
      setPlotSelected(null);
      plotSelectedRef.current = null;
      claimchainRef.current = null;
      setClaimchain({
        size: 1,
        plots: [],
      });
    }
  };

  useFetchPublicUserInfo(true);

  const value = {
    plotSelected,
    mapRef,
    setPlotSelected: _setPlotSelected,
    selectPolygon,
    unSelectPolygon,
    setCenter,
    setClaimchains,
    claimchains,
    claimchain,
    claimchainRef,
    fetchingClaimChain,
    filter,
    setFilter,
    loaded,
    setLoaded,
    plotsSelected,
    setPlotsSelected,
    selectedImage,
    contractCert,
    setContractCert,
    setSelectedImage,
    imageList,
    setImageList,
    claimchainsCluster,
    setClaimchainsCluster,
    isOpenVerify,
    onCloseVerify,
    onOpenVerify,
    getPlotData,
    cert,
    setCert,
    certVerify,
    setCertVerify,
    warningVerify,
    setWarningVerify,
    isOpenLogin,
    onOpenLogin,
    onCloseLogin,
    buckets,
    setBuckets,
  };
  return (
    <MainContext.Provider value={value}>
      <Header />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        {children}
      </Box>
    </MainContext.Provider>
  );
}

Layout.propTypes = {
  children: PropTypes.any,
};
